import type { CartItem, CartData } from 'types'
import { getCart } from '../../resources/shopify-cart'

export const waitForCartUpdate = async (
  expectedVariantId: string | number,
  maxAttempts: number = 10,
  delayMs: number = 50
): Promise<CartData | null> => {
  for (let attempt = 0; attempt < maxAttempts; attempt++) {
    const cart = await getCart()
    if (
      cart?.items?.some(
        (item: CartItem) => item.variant_id == expectedVariantId
      )
    ) {
      return cart
    }
    await new Promise((resolve) => {
      setTimeout(resolve, delayMs)
    })
  }
  return (await getCart()) || null
}
